module.exports = __webpack_public_path__ + "media/images/noticia02-n-addb436801cd914da6a877fcc9fb1db1.jpg";